import React from 'react';

function SplashScreen() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #0A192F 0%, #1E293B 100%)' }}>
      <div className="text-center animate-fadeIn">
        <div className="mb-8 animate-float">
          <h1 className="font-emblema text-7xl md:text-9xl text-gradient">
            MERTT
          </h1>
        </div>
        <div className="flex items-center justify-center space-x-2">
          <div className="w-3 h-3 bg-cyan-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
          <div className="w-3 h-3 bg-cyan-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-3 h-3 bg-cyan-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>
        <p className="mt-8 text-lg text-gray-400">Loading...</p>
      </div>
    </div>
  );
}

export default SplashScreen;